export * from './new-cuenta-dialog.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/new-cuenta-dialog/index.ts